import { isAfter } from 'date-fns'

export function* range(start: number, end?: number, step: number = 1): Generator<number> {
  if (end === undefined) {
    end = start
    start = 0
  }
  if (step === 0) throw new Error('step cannot be 0')

  if (step > 0) {
    for (let i = start; i < end; i += step) {
      yield i
    }
  } else {
    for (let i = start; i > end; i += step) {
      yield i
    }
  }
}

export function getSelectionCoords() {
  const selection = window.getSelection()
  if (!selection || selection.rangeCount === 0 || selection.isCollapsed)
    return {
      top: 0,
      left: 0,
      width: 0,
      height: 0,
      isCollapsed: true,
    }

  const range = selection.getRangeAt(0)
  const rect = range.getBoundingClientRect()

  return {
    top: rect.top + window.scrollY,
    left: rect.left + window.scrollX,
    width: rect.width,
    height: rect.height,
    isCollapsed: false,
  }
}

export function isValidUrl(url: string): boolean {
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}

export function calGrade(enrollmentStartDate?: Date): number {
  if (!enrollmentStartDate) return 0
  const now = new Date()
  const thisYear = now.getFullYear()
  const aprilFirst = new Date(thisYear, 3, 1)
  const enrollmentStartYear = enrollmentStartDate.getFullYear()
  return thisYear < enrollmentStartYear
    ? 0
    : thisYear - enrollmentStartYear + (isAfter(now, aprilFirst) ? 1 : 0)
}
